var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 12381"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6316",
    transform: "translate(1 3.187)",
    style: {
      stroke: "#fff",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 19,
    rx: 4,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 19.5,
    height: 17.5,
    rx: 3.25,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 16",
    transform: "translate(.999 10.187)",
    style: {
      stroke: "#fff",
      strokeWidth: "1.5px",
      fill: "none"
    },
    d: "M0 0h20"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 17",
    transform: "translate(7 .812)",
    style: {
      stroke: "#fff",
      strokeWidth: "1.5px",
      fill: "none"
    },
    d: "M0 0v5.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 18",
    transform: "translate(16 .812)",
    style: {
      stroke: "#fff",
      strokeWidth: "1.5px",
      fill: "none"
    },
    d: "M0 0v5.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCal);
export default __webpack_public_path__ + "static/media/icon_cal.b0352cea6d51b7112dce98d1ae4feab3.svg";
export { ForwardRef as ReactComponent };